<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
		//Design system components
	import { Button, Checkbox } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Device } from '../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore.sensors,
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest = await postReq(`/device/sensor/settings/pir_motion_led`, {
				id,
				enabled: Number(checked),
			});
			onSettingsResponse(res, device);
			waitForResponse = false;
		};

	let checked = settings.motion_led,
		waitForResponse = false;
</script>

<Checkbox class="mb-s" size="m" bind:checked id="checkbox-vzngnrp"
	>{$format('external_power_supply_enable')}</Checkbox
>

<Button size="m" width="full" loading={waitForResponse} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
